import "@/styles/index.css";

import { Auth0Provider } from "@auth0/auth0-react";
import { StyledEngineProvider } from "@mui/styled-engine-sc";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { PersistGate } from "redux-persist/integration/react";

import App from "@/App";
import getAuthConfig from "@/auth-config";
import { GraphQLProvider } from "@/providers";
import { persistor, store } from "@/redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));

const { audience, clientId, connectionScope, domain } = getAuthConfig();

const providerConfig = {
    authorizationParams: {
        ...(audience ? { audience } : null),
        access_type: "offline",
        approval_prompt: "force",
        connection_scope: connectionScope,
        scope: "offline_access profile roles",
        redirect_uri: window.location.origin,
    },
    cacheLocation: "localstorage",
    clientId,
    domain,
};

root.render(
    <Auth0Provider {...providerConfig}>
        <BrowserRouter>
            <GraphQLProvider>
                <StyledEngineProvider injectFirst>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            <App />
                        </PersistGate>
                    </Provider>
                </StyledEngineProvider>
            </GraphQLProvider>
        </BrowserRouter>
    </Auth0Provider>,
);
